import React, { useState, useEffect } from "react";
import logo from "./images/logo.svg";
import { NavLink, useHistory } from "react-router-dom";
import $ from 'jquery';


import paid from "./images/paid.png";
import trial from "./images/trial.svg";

import api from "./api";
import { Modal } from "bootstrap";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

function getAPP() {
  // Show loader
  const loader = document.createElement("img");
  loader.src = "loader.gif";
  document.body.appendChild(loader);

  api.get(process.env.REACT_APP_DOWNLOAD_CSV, { responseType: 'blob' }) // important!
    .then((res) => {
      const blob = new Blob([res.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'user_reports.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch((err) => {
      console.error("Error generating CSV:", err);
      alert("Failed to generate CSV");
    });
}

function Dashboard({ isLoggedIn }) {
  const history = useHistory();
  const location = useLocation();
  const [resetPassMessage, setResetPassMessage] = useState(null);
  const [resetPassError, setResetPassError] = useState(false);
  const [loggedIn, setLoggedIn] = useState(localStorage.getItem('token'));

  const [loading, setLoading] = useState(true);
  
  
  // useEffect(() => {
  //   if (!isLoggedIn) {
  //     history.push('/login');
  //     localStorage.setItem('isLoggedIn', false);
  //   }
  // }, [isLoggedIn, history]);

  useEffect(() => {
    return () => {
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(b => b.remove());
    }
  }, [location]);

  const [data, setData] = useState([]);
  // useEffect(() => {
  //   fetch("http://brokerapp.local/index.php?xAction=users_V2")
  //     .then((response) => response.json())
  //     .then((data) => setData(data.data));
  // }, []);

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   console.log("Token:", token);

  //   // 1️⃣ Redirect to login if token is missing
  //   if (!token) {
  //     history.push("/login");
  //     return;
  //   }

  //   const fetchUsers = async () => {
  //     try {
  //       // 2️⃣ Call the protected API
  //       // const res = await api.get("", { params: { xAction: "users_V2" } });
  //       const res = await api.get("?xAction=users_V2", {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`
  //         }
  //       });

  //       if (res.data.status === 1) {
  //         setData(res.data.data); // Successful, set data
  //       } else {
  //         // 3️⃣ Invalid or expired token
  //         localStorage.removeItem("token");
  //         history.push("/login");
  //       }
  //     } catch (err) {
  //       console.error("Unauthorized or API error:", err);
  //       localStorage.removeItem("token");
  //       history.push("/login");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchUsers();
  // }, [history]);

  // useEffect(() => {
  //   let isMounted = true;
  
  //   const fetchUsers = async () => {
  //     try {
  //       const res = await api.get("?xAction=users_V2");
  
  //       if (isMounted) {
  //         if (res.data.status === 1) {
  //           setData(res.data.data);
  //         } else {
  //           localStorage.removeItem("token");
  //           history.push("/login");
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Unauthorized or API error:", err);
  //       localStorage.removeItem("token");
  //       if (isMounted) history.push("/login");
  //     } finally {
  //       if (isMounted) setLoading(false);
  //     }
  //   };
  
  //   fetchUsers();
  
  //   return () => {
  //     isMounted = false; // cleanup async calls
  //   };
  // }, [history]);

  useEffect(() => {
     if (data.length > 0) return; // prevent repeated calls
    let isMounted = true;
  
    const fetchUsers = async () => {
      try {
        const res = await api.get(process.env.REACT_APP_USERS_V2);
  
        if (isMounted) {
          if (res.data.status === 1) {
            setData(res.data.data);
          } else {
            localStorage.removeItem("token");
            history.push("/login");
          }
        }
      } catch (err) {
        console.error("Unauthorized or API error:", err);
        localStorage.removeItem("token");
        if (isMounted) history.push("/login");
      } finally {
        if (isMounted) setLoading(false);
      }
    };
  
    fetchUsers();
  
    return () => {
      isMounted = false;
    };
  }, []); // ✅ empty array so it only runs once
  


  useEffect(() => {
    data.forEach((item) => {
      const activationMessage = document.getElementById(
        `activationMessage_${item.user_id}`
      );
      const checkbox = document.getElementById(`bopis_${item.user_id}`);
      const activationButtonYes = document.getElementById(
        `activationButtonYes_${item.user_id}`
      );
      const activationButtonNo = document.getElementById(
        `activationButtonNo_${item.user_id}`
      );
      const deActivationButtonYes = document.getElementById(
        `deActivationButtonYes_${item.user_id}`
      );

      // checkbox.addEventListener("change", function () {
      //   if (this.checked) {
      //     activationMessage.textContent =
      //       "Are you sure you want to deactivate the city?";
      //     deActivationButtonYes.style.display = "block"; // Show the button
      //     activationButtonYes.style.display = "none"; // hide the button
      //   } else {
      //     activationMessage.textContent =
      //       "Are You Sure You Want Activate The City?";
      //     deActivationButtonYes.style.display = "none"; // Hide the button
      //     activationButtonYes.style.display = "block"; // Show the button
      //   }
      // });
    });
  }, [data]);

  const loadData = () => {
    // fetch("http://brokerapp.local/index.php?xAction=users_V2")
    //   .then((response) => response.json())
    //   .then((data) => setData(data.data));
    api.get(process.env.REACT_APP_USERS_V2)
     .then((res) => setData(res.data.data));
  };

  function handleActivationChange(user_id, city_id, is_active) {
    // // const isChecked = event.target.checked;
    // //if (isChecked) {

    // fetch(
    //   "http://brokerapp.local/index.php?xAction=" +
    //     (is_active ? "userCityActivation" : "userCityDeactivation"),
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       user_id: user_id,
    //       city_id: city_id,
    //     }),
    //   }
    // )
    
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log(data.message);
    //     var toggle = document.getElementById("bopis_" + user_id);
    //     //toggle.checked = true;
    //     //toggle.checked = is_active;

    //     // Call the API again to get the updated data
    //     fetch("http://brokerapp.local/index.php?xAction=users_V2")
    //       .then((response) => response.json())
    //       .then((data) => setData(data.data));

    //     // Update the UI or show a success message
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     // Show an error message to the user
    //   });
    // // }

    api.post(`?xAction=${is_active ? "userCityActivation" : "userCityDeactivation"}`, {
      user_id,
      city_id,
    })
    .then((res) => { 
      console.log(res.data.message);
    
      // Update toggle button UI
      const toggle = document.getElementById("bopis_" + user_id);
    
      // Refresh user list
      return api.get(process.env.REACT_APP_USERS_V2);
    })
    .then((res2) => {
      setData(res2.data.data);
    })
    .catch((err) => {
      console.error("Error updating user status:", err);
    });
  }

  function handleSubscriptionButton(userId, SubscriptionId) {
    let activeButtonId;
    if (SubscriptionId == 1) {
      activeButtonId = `btnTrial_${userId}`;
    } else if (SubscriptionId == 0) {
      activeButtonId = `btnPaid_${userId}`;
    }
    
    // Get a reference to the active button
    const activeButton = document.getElementById(activeButtonId);
    
    // Add the "active" class to the active button if it exists
    if (activeButton) {
      activeButton.classList.add('active');
    }
  
    // Get a reference to the other button
    const otherButton = SubscriptionId == 1 ? document.getElementById(`btnPaid_${userId}`) : document.getElementById(`btnTrial_${userId}`);
  
    // Remove the "active" class from the other button if it exists
    if (otherButton) {
      otherButton.classList.remove('active');
    }
  }
  
  
  function handleApplyButton(userId,cityId) {

    
    const trialButton = document.getElementById(`btnTrial_${userId}`);
    const paidButton = document.getElementById(`btnPaid_${userId}`);
    const errorText = document.getElementById(`errorText_${userId}`);
    
    let isTrial = false;
    
    if (trialButton.classList.contains('active')) {
      // "Trial" button is active
      errorText.style.display = 'none';
      isTrial = true;
    } else if (paidButton.classList.contains('active')) {
      // "Paid" button is active
      errorText.style.display = 'none';
      isTrial = false;
    } else {
      errorText.style.display = 'block';
      // Neither button is active
      return;
    }
  
    

    const data = {
      user_id: userId,
      city_id: cityId,
      is_trial: isTrial ? 1 : 0
    };
    
  
    // fetch('http://brokerapp.local/index.php?xAction=userCityActivation_V2', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify(data)
    // })
    // .then(response => response.json())
    // .then(data => {
    //   console.log(data);
    //   // Handle successful API response
    //    // Call the API again to get the updated data
       
       
    //     // $(`#Activation_${userId}`).modal('hide');
    //       // $(`#Activation_${userId}`).modal('hide');

    //   //  fetch("http://brokerapp.local/index.php?xAction=users_V2")
    //   //  .then((response) => response.json())
    //   //  .then((data) => setData(data.data));
    //   api.get("?xAction=users_V2")
    //    .then((res) => setData(res.data.data));
      
    api.post(process.env.REACT_APP_USER_CITY_ACTIVATION_V2, data)
      .then((res) => {
        console.log(res.data);
        
        if (res.data.status === 1) {
          // success handling
          console.log("User activated successfully");

          window.location.reload(); // to reflect the changes immediately
          // reload updated users list
          // api.get(process.env.REACT_APP_USERS_V2)
          //   .then((res2) => {
          //     setData(res2.data.data)
              
          //   });
        } else {
          console.error("Activation failed:", res.data.message);
          alert("Activation failed: " + res.data.message);
          // alert(res.data.message);
        }

        // If you want to hide modal
        // const modalEl = document.querySelector(`#Activation_${userId}`);
        // if (modalEl) {
        //   const closeBtn = modalEl.querySelector("[data-bs-dismiss='modal']");
        //   if (closeBtn) closeBtn.click();
        // }
      })
    .catch(error => {
      // Handle API error
    });

    
  }
  


  function handleCancelButton(userId,cityId)
  {
  
    // fetch(
    //   // "http://brokerapp.local/index.php?xAction=userCityDeactivation",
    //   "http://brokerapp.local/index.php?xAction=userCityDeactivation",
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       user_id: userId,
    //       city_id: cityId,
    //     }),
    //   }
    // )
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log(data.message);
    //     // Call the API again to get the updated data
    //     fetch("http://brokerapp.local/index.php?xAction=users_V2")
    //       .then((response) => response.json())
    //       .then((data) => setData(data.data));

    //     // Update the UI or show a success message
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     // Show an error message to the user
    //   });

    api.post(process.env.REACT_APP_USER_CITY_DEACTIVATION, {
      user_id: userId,
      city_id: cityId,
    })
      .then((res) => {
        console.log(res.data.message);
    
        // refresh the users list
        return api.get(process.env.REACT_APP_USERS_V2);
      })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.error("Deactivation failed:", err);
        alert("Something went wrong while deactivating user.");
      });
      
  }
  
  

  

  return (
    !loggedIn ? <></> :
    <>
      <div id="dashboard">
        <div className="panel_row">
          <div className="leftpanel">
            <ul className="left_menu">
              <li>
                <NavLink to="/" className="logo">
                  <img src={logo} height="40" />
                </NavLink>
              </li>
              <li>
                <NavLink to="#">User List</NavLink>
              </li>
              <li>
              <NavLink to="/login" onClick={() => localStorage.removeItem("token")} >
                Logout
              </NavLink>
              </li>
            </ul>
          </div>

          <div className="rightpanel">
            <div className="content">
              <div className="title_with_button">
                <h1>User List </h1>

                <NavLink to="#" className="btn_download" onClick={getAPP}>
                  <i className="fa fa-file-excel-o" aria-hidden="true"></i>{" "}
                  <span>Download</span>
                </NavLink>
              </div>
              <div className="table-responsive mt-3">
                <table className="table">
                  <thead>
                    <tr>
                      {/* <th>Email</th> */}
                      <th>Customer</th>
                      <th>Contact</th>
                      {/* <th>Company Name</th> */}
                      <th>Subscription</th>
                      {/* <th>Registration Date</th> */}
                      <th>City Activation</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Package Renewal</th>
                      <th>Reset Password</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item) => (
                      <tr key={item.user_id}>
                        <td>
                          <b>{item.full_name}</b>
                          <br></br>
                          {item.company_name}
                        </td>
                        {/* <td>{item.full_name}</td> */}
                        <td>
                          {item.phone_number}
                          <br></br>
                          {item.email}
                        </td>
                        {/* <td>{item.company_name}</td> */}
                        <td>
                          <b>{item.city_name}</b>
                          <br></br>
                          {item.registration_date}
                        </td>
                        {/* <td>{item.registration_date}</td> */}

                        <td>

                          <div className="on-off-toggle">
                            <input
                              className="on-off-toggle__input"
                              type="checkbox"
                              id={"bopis_" + item.user_id}
                              data-bs-toggle="modal"
                              data-bs-target={"#Activation_" + item.user_id}
                              checked={item.userCityActivationStatus == 1}
                            />
                            <label
                              for={"bopis_" + item.user_id}
                              className="on-off-toggle__slider"
                            ></label>
                          </div>
                          <br></br>
                          <p style={{ textTransform: "uppercase", margin: 0, marginTop: "5px" }}>{item.is_trial == 1 ? <><i className='icon-trial'></i>Trial</> : item.is_trial == 0 ? <><i className='icon-paid'></i>Paid</> : null}
                          </p>

                        </td>

                        <td style={{ width: '20px' }}>
                          {item.start_date}
                        </td>

                        <td>
                          {item.end_date}
                        </td>

                        {/* Package Renewal Button */}
                        <td>
                          <NavLink
                            to="#"
                            className="btn btn_green"
                            data-bs-toggle={
                              item.userCityActivationStatus == 1 ? "modal" : "modal"
                            }
                            data-bs-target={
                              item.userCityActivationStatus == 1
                                ? "#package-renewal_" + item.user_id
                                : "#cityNotActiveModal"
                            }
                            // onClick={(e) => {
                            //   if (item.userCityActivationStatus == 1) {
                            //     handlePackageRenewal(item.user_id);
                            //   }
                            // }}
                          >
                            <i className="fa fa-retweet" aria-hidden="true"></i>
                          </NavLink>
                        </td>

                        {/* Reset Password Button */}
                        <td>
                          <NavLink
                            to="#"
                            className="btn btn_green"
                            data-bs-toggle="modal"
                            data-bs-target={"#ResetPassword_" + item.user_id}
                            onClick={() => handleGeneratePassword(item.user_id)}
                          >
                            <i className="fa fa-key" aria-hidden="true"></i>
                          </NavLink>
                        </td>

                        <div className="modal fade" id={'Activation_' + item.user_id} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content cityActivation">
                              <button type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                              <div className="modal-body text-center">

                                <h5>Choose between Trial or Paid options to access the service and enjoy the benefits.</h5>
                                {/* <h5 id={'activationMessage_'+item.user_id}>Are You Sure You Want Activate The City?</h5>
                                <div className="button_group">
                                  <button type="button" id={'activationButtonYes_'+item.user_id} className="btn btn_green" onClick={() => handleActivationChange(item.user_id, item.city_id,true)}  data-bs-dismiss="modal">Yes</button>
                                  <button type="button" id={'deActivationButtonYes_'+item.user_id} className="btn btn_green" onClick={() => handleActivationChange(item.user_id, item.city_id,false)}  data-bs-dismiss="modal">Yes</button>
                                  <button type="button" id={'activationButtonNo_'+item.user_id} className="btn btn_no" data-bs-dismiss="modal">no</button>
                                </div> */}

                                <div class='btn_group mt-5'>
                                  <a id={'btnTrial_' + item.user_id} href='#' onClick={(e) => {
                                    e.preventDefault();
                                    handleSubscriptionButton(item.user_id, 1)
                                  }} className={item.is_trial == 1 ? "active" : ""} ><i class='icon-trial'></i> Trial</a>
                                  <a id={'btnPaid_' + item.user_id} href='#' onClick={(e) => {
                                    e.preventDefault();
                                    handleSubscriptionButton(item.user_id, 0)
                                  }} className={item.is_trial == 0 ? "active" : ""}><i class='icon-paid'></i> Paid</a>
                                </div>
                                <span id={'errorText_' + item.user_id} style={{ color: '#FF0000', marginTop: '10px', display: 'block', fontSize: '14px', display: "none" }}>Please select at least one subscription</span>
                                <div class='btn_group2 mt-3'>

                                  <a id={'btnApply_' + item.user_id} href='#' onClick={() => handleApplyButton(item.user_id, item.city_id)} class='btn_apply' 
                                  >Apply</a>
                                  {/* data-bs-dismiss="modal" */}
                                  <a id={'btnCancel_' + item.user_id} href='#' onClick={() => handleCancelButton(item.user_id, item.city_id)} class='btn_cancel' data-bs-dismiss="modal">Cancel Membership</a>

                                </div>

                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Reset Password Modal */}
                        <div
                          className="modal fade"
                          id={"ResetPassword_" + item.user_id}
                          tabIndex="-1"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content cityActivation">
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>

                              <div className="modal-body text-center">
                                <h5>Reset Password</h5>

                                <div className="form-group mt-3 px-4">
                                  <label>Generated Password</label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id={"generatedPassword_" + item.user_id}
                                      readOnly={true}
                                    />
                                    <button
                                      className="btn btn-secondary"
                                      type="button"
                                      id={"copyButton_" + item.user_id}
                                      onClick={() => handleCopyPassword(item.user_id)}
                                    >
                                      Copy
                                    </button>
                                  </div>
                                  <span
                                    id={"copyMsg_" + item.user_id}
                                    style={{
                                      display: "none",
                                      color: "green",
                                      fontSize: "12px",
                                      marginTop: "5px",
                                      display: "block",
                                    }}
                                  >
                                    {/* Copied! */}
                                  </span>
                                </div>

                                {resetPassMessage && (
                                  <div className={`alert ${resetPassError ? "alert-danger" : "alert-success"}`}>
                                  {resetPassMessage}
                                  </div>
                                )}

                                <div className="button_group mt-4">
                                  <button
                                    type="button"
                                    className="btn btn-outline-success me-2"
                                    onClick={() => handleSavePassword(item.user_id, setResetPassMessage, setResetPassError)}
                                  >
                                    Save
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    data-bs-dismiss="modal"
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Renewal Modal */}
                        <div
                          className="modal fade"
                          id={"package-renewal_" + item.user_id}
                          tabIndex="-1"
                          aria-labelledby="packageRenewalLabel"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title" id="packageRenewalLabel">
                                  Renew Package for {item.full_name}
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>

                              {/* Call the component here */}
                              {/* <RenewalModal item={item} submitRenewal={submitRenewal} /> */}
                              <RenewalModal item={item} submitRenewal={submitRenewal} refresh={loadData} setData={setData} />

                            </div>
                          </div>
                        </div>

                        {/* City Not Active Popup */}
                        <div
                          className="modal fade"
                          id="cityNotActiveModal"
                          tabIndex="-1"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Action Not Allowed</h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body">
                                <p>Please activate city first before renewing the package.</p>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-dismiss="modal"
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div id="footer_login">propstackCopyright © 2023 // Propstack</div>
          </div>
        </div>

      </div>
    </>
  );
}

function RenewalModal({ item, submitRenewal, setData }) {
  const today = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(
    item.start_date ? item.start_date.substring(0, 10) : today
  );
  const [endDate, setEndDate] = useState(
    item.end_date ? item.end_date.substring(0, 10) : today
  );

  const [message, setMessage] = useState(null);   // success/error message
  const [isError, setIsError] = useState(false);  // flag for styling

  // const [data, setData] = useState([]);

  const handleSubmit = (e) => {
    submitRenewal(
      e,
      item.user_id,
      startDate,
      endDate,
      item.city_id,
      item.is_trial,
      (success, msg) => {
        setIsError(!success);
        setMessage(msg);
      },
      setData,
      setMessage
    );
  };

  return (
    <div className="modal-body">
      {/* Show message if exists */}
      {message && (
        <div className={`alert ${isError ? "alert-danger" : "alert-success"}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* Start Date */}
        <div className="mb-3">
          <label className="form-label">Start Date</label>
          <input
            type="date"
            className="form-control"
            name="start_date"
            value={startDate}
            disabled
          />
        </div>

        {/* End Date */}
        <div className="mb-3">
          <label className="form-label">End Date</label>
          <input
            type="date"
            className="form-control"
            name="end_date"
            value={endDate}
            min={startDate}
            onChange={(e) => setEndDate(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn btn-success">
          Renew Now
        </button>
      </form>
    </div>
  );
}


// Store generated passwords temporarily
const generatedPasswords = {};

const generateRandomPassword = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let password = "";
  for (let i = 0; i < 9; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return password;
};

const handleGeneratePassword = (userId) => {
  const password = generateRandomPassword();
  generatedPasswords[userId] = password;

  const input = document.getElementById("generatedPassword_" + userId);
  if (input) input.value = password;
};

const handleCopyPassword = (userId) => {
  const input = document.getElementById("generatedPassword_" + userId);
  const button = document.getElementById("copyButton_" + userId);
  const msg = document.getElementById("copyMsg_" + userId);

  if (input && button && msg) {
    input.select();
    document.execCommand("copy");

    button.innerText = "Copied!";
    button.disabled = true;
    msg.style.display = "block";

    setTimeout(() => {
      button.innerText = "Copy";
      button.disabled = false;
      msg.style.display = "none";
    }, 5000);
  }
};

const handleSavePassword = (userId, setResetPassMessage, setResetPassError) => {
  const newPassword = generatedPasswords[userId];
  if (!newPassword) return;

  console.log("Saving password for user");


  // fetch('http://brokerapp.local/index.php?xAction=reset_password', {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify({ user_id: userId, password: newPassword }),
  // })
  //   .then(response => response.json())
  //   .then((data) => {
  //     console.log("Password reset successful");
  //   })
  api.post(process.env.REACT_APP_RESET_PASSWORD, { user_id: userId, password: newPassword })
     .then((res) => { 
      console.log("Password reset successful", res);
      setResetPassError(false);
      setResetPassMessage(res.data.message);
    })
    .catch((err) => {
      console.error("Error resetting password:", err);
      setResetPassMessage(err.response.data.message);
      setResetPassError(true);
    })
    .finally(() => {
      setTimeout(() => {
        const modalEl = document.querySelector(`#ResetPassword_${userId}`);
        if (modalEl) {
          const closeBtn = modalEl.querySelector("[data-bs-dismiss='modal']");
          if (closeBtn) closeBtn.click();
        }
        setResetPassMessage(null);
      }, 2000);
    })
    ;
};

const handlePackageRenewal = (userId) => {
  console.log("Opening renewal modal for user:", userId);
  // If you want to store the selected user in state:
  // setSelectedUser(userId);
};

const submitRenewal = (e, userId, startDate, endDate, cityId, isTrial, cb, setData, setMessage) => {
  e.preventDefault();

  // fetch("http://brokerapp.local/index.php?xAction=renewUserPackage", {
  //   method: "POST",
  //   headers: { "Content-Type": "application/json" },
  //   body: JSON.stringify({
  //     user_id: userId,
  //     start_date: startDate,
  //     end_date: endDate,
  //     city_id: cityId,
  //     is_trial: isTrial,
  //   }),
  // })
  
  //   .then((response) => response.json())
  //   .then((data) => {
  //     if (data.status) {
  //       console.log("Package renewed successfully");
  //       cb(true, "Package renewed successfully!");
       
  //     } else {
  //       console.error("Renewal failed:", data.message);
  //       cb(false, "Renewal failed: " + data.message);
  //     }

  //     setTimeout(() => {
  //       if (refresh) refresh();

  //       const modalEl = document.querySelector(`#package-renewal_${userId}`);
  //       if (modalEl) {
  //         const closeBtn = modalEl.querySelector("[data-bs-dismiss='modal']");
  //         if (closeBtn) closeBtn.click();
  //       }
  //     }, 3000);
  //   })
  api.post(process.env.REACT_APP_RENEWAL_PACKAGE, {
    user_id: userId,
    start_date: startDate,
    end_date: endDate,
    city_id: cityId,
    is_trial: isTrial,
  })
  .then((res) => { 
    if (res.data.status) { 
      console.log("Package renewed successfully");
      cb(true, "Package renewed successfully!");  
    } else {
      console.error("Renewal failed:", res.data.message);
      cb(false, "Renewal failed: " + res.data.message);
    }

    setTimeout(() => {
      // if (refresh) refresh();
      setData(prevData => {
        return prevData.map(user => {
          if (user.user_id === userId) {
            return {...user, start_date: startDate, end_date: endDate };
          }
          return user;
        });
      }); // trigger re-render

      const modalEl = document.querySelector(`#package-renewal_${userId}`);
      if (modalEl) {
        const closeBtn = modalEl.querySelector("[data-bs-dismiss='modal']");
        if (closeBtn) closeBtn.click();
      }
      setMessage(null);
    }, 2000);
  })
    .catch((err) => {
      console.error("Error renewing package:", err);
      cb(false, "Something went wrong while renewing!");
      setTimeout(() => {
        // if (refresh) refresh();

        const modalEl = document.querySelector(`#package-renewal_${userId}`);
        if (modalEl) {
          const closeBtn = modalEl.querySelector("[data-bs-dismiss='modal']");
          if (closeBtn) closeBtn.click();
        }
      }, 2000);
      setMessage(null);
    });
};

export default Dashboard;
